<template>
  <v-container id="menus" tag="section">
    <base-v-component heading="Menú " />

    <base-material-card
      color="indigo"
      icon="mdi-basket"
      inline
      class="px-5 py-3"
    >
      <v-toolbar flat color="white">
        <v-btn color="grey" dark class="mb-2 mr-4" @click="goBack"
          >Volver</v-btn
        >
        <v-btn
          color="success"
          dark
          class="mb-2"
          @click="save"
          :loading="loadingGuardar"
          >Guardar</v-btn
        >
        <!-- <v-btn
          color="info"
          dark
          class="mb-2 ml-4"
          @click="accion = 'configurar'"
          v-if="!isConfigurar"
          >Configurar</v-btn
        > -->
      </v-toolbar>

      <v-card-text>
        <h3>{{ title }}</h3>
        <v-spacer />
        <v-row align="center">
          <v-col cols="12" md="3">
            <v-btn small color="primary" @click="addGrupo">Añadir Grupo</v-btn>
          </v-col>
          <v-col cols="12" md="6">
            <v-select
              :items="idiomas"
              v-model="langSeleccionado"
              label="Selección idioma"
              outline
            ></v-select>
          </v-col>
        </v-row>
        <v-card elevation="100">
          <v-card-text>
            <v-row>
              <v-col cols="12" md="4">
                <v-text-field
                  v-model="nombreMenu"
                  label="Nombre"
                  autofocus
                ></v-text-field> </v-col
              ><v-col cols="12" md="4">
                <v-text-field
                  v-model="descripcionMenu"
                  label="Descripción"
                  autofocus
                ></v-text-field>
              </v-col>

              <template v-if="!menu.imagen">
                <v-col cols="12" md="4">
                  <v-file-input
                    accept="image/*"
                    label="Imagen Logo"
                    v-model="imagenAux"
                  ></v-file-input>
                </v-col>
              </template>
              <template v-else>
                <v-col cols="12" md="2">
                  <v-img :src="menu.imagen"></v-img>
                </v-col>

                <v-col cols="12" md="1">
                  <v-btn
                    text
                    @click="
                      menu.imagen = null;
                      imagenAux = null;
                    "
                    >Cambiar</v-btn
                  >
                </v-col>
              </template>
              <v-col cols="12" md="3">
                <v-select
                  :items="categorias"
                  v-model="menu.categoria"
                  label="categoria"
                ></v-select>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-text>
            <v-row>
              <v-col v-for="(item, i) in gruposMenu" :key="i" cols="12" md="4">
                <v-item>
                  <v-card
                    slot-scope="{ active }"
                    :color="active ? 'primary' : ''"
                    elevation="100"
                  >
                    <v-toolbar color="secondary" dark>
                      <v-toolbar-title class="white--text">
                        <v-text-field
                          :value="item.nombreMostrar"
                          @change="cambioNombreGrupo($event, item)"
                          label="Nombre grupo"
                        />

                        <h6>Mensajito</h6>
                      </v-toolbar-title>

                      <v-spacer></v-spacer>
                    </v-toolbar>
                    <v-list>
                      <v-list-item
                        v-for="(op, i_a) in item.productosGrupo"
                        :key="i_a"
                      >
                        <v-list-item-title>{{
                          op.nombreMostrar
                        }}</v-list-item-title>
                        <v-list-item-action
                          ><v-btn
                            icon
                            @click="borrarProductoGrupo(op)"
                            small
                            color="red"
                            text
                            ><v-icon>mdi-delete</v-icon></v-btn
                          ></v-list-item-action
                        >
                      </v-list-item>
                      <v-card-actions>
                        <v-btn small rounded color="red" @click="borrarGrupo(i)"
                          >BORRAR</v-btn
                        >
                        <v-spacer />
                        <v-btn
                          small
                          rounded
                          color="success"
                          @click="addProductoMetodo(item.id)"
                          ><v-icon>mdi-plus</v-icon></v-btn
                        >
                      </v-card-actions>
                    </v-list>
                  </v-card>
                </v-item>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-card-text>
    </base-material-card>
    <v-dialog max-width="700" v-model="addProductoDialog">
      <v-card>
        <v-card-title> Añadir producto al menú {{ nombreMenu }} </v-card-title>
        <v-card-text>
          <v-row align="center" justify="center">
            <v-col cols="12" md="6">
              <v-autocomplete
                :items="productosSelect"
                v-model="addProducto.producto"
                label="Producto"
              />
            </v-col>
            <v-col cols="12" md="6">
              <v-btn
                rounded
                outlined
                color="primary"
                small
                @click="addProductoMetodoConfirmar"
                >Añadir</v-btn
              >
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
  import { key } from 'firebase-key';
  import { mapState, mapGetters } from 'vuex';
  import { mostrarIdioma } from '@/utils/utils.js';
  export default {
    data: () => {
      return {
        valorAuxInput: '',
        addProducto: {
          producto: null,
          idgrupo: null,
        },
        addProductoDialog: false,
        loadingGuardar: false,
        imagenAux: null,
        menu: {
          id: null,
          nombre: [],
          descripcion: [],
          grupos: [],
          categoria: '',
          imagen: '',
          menu: true,
        },
      };
    },
    computed: {
      ...mapGetters({
        negocio: 'app/negocioGestObj',
        categorias: 'categorias/getCategoriasSelect',
        productos: 'productos/productosListadoTodos',
      }),
      productosSelect() {
        console.log(this.productos);
        return this.productos
          .filter((p) => !p.menu)
          .map((p) => {
            return {
              value: p.id,
              text: p.nombreMostrar,
            };
          });
      },
      langSeleccionado: {
        get() {
          return this.$store.state.langSeleccionado;
        },
        set(v) {
          this.$store.commit('setLangSeleccionado', v);
        },
      },
      nombreMenu: {
        get() {
          this.langSeleccionado;
          return this.menu.nombre.length > 0
            ? this.menu.nombre.find((n) => n.lang == this.langSeleccionado).text
            : '';
        },
        set(v) {
          let f = this.menu.nombre.findIndex(
            (n) => n.lang == this.langSeleccionado
          );
          if (f > -1) this.menu.nombre[f].text = v;
        },
      },
      descripcionMenu: {
        get() {
          return this.menu.descripcion.length > 0
            ? this.menu.descripcion.find((n) => n.lang == this.langSeleccionado)
                .text
            : '';
        },
        set(v) {
          let f = this.menu.descripcion.findIndex(
            (n) => n.lang == this.langSeleccionado
          );
          if (f > -1) this.menu.descripcion[f].text = v;
        },
      },
      ...mapState({
        idiomas: 'idiomas',
        langDefecto: 'langDefecto',
      }),
      gruposMenu: {
        get() {
          return this.menu.grupos.map((m) => {
            return {
              ...m,
              nombreMostrar: this.mostrarNombre(m.nombre),
              productosGrupo: Array.isArray(m.productosGrupo)
                ? m.productosGrupo.map((p) => {
                    let found = this.productos.find(
                      (pGen) => pGen.id == p.producto
                    );

                    return {
                      ...p,
                      nombreMostrar: !!found
                        ? found.nombreMostrar
                        : 'Sin nombre',
                    };
                  })
                : [],
            };
          });
        },
        set(v) {
          //console.log(v);
        },
      },
      title() {
        let res = '';
        switch (this.accion) {
          case 'configurar':
            res = 'Construir producto';
            break;
          case 'compatibilidad':
            res = 'Manejar compatibilidades';
            break;
          case 'mapeo':
            res = 'Manejar mapeo Neo';
            break;
        }
        return res;
      },
    },
    methods: {
      cambioNombreGrupo(s, obj) {
        //this.menu.grupos.findIndex((g) => g.id == obj.id);
        let foundI = obj.nombre.findIndex(
          (e) => e.lang == this.langSeleccionado
        );
        if (foundI > -1) {
          obj.nombre[foundI].text = s;
        }
        console.log(this.menu.grupos);
      },
      mostrarNombre(str) {
        //return mostrarIdioma(s);
        var found = str.find((e) => e.lang == this.langSeleccionado);
        return found ? found.text : '';
      },
      addProductoMetodo(idgrupo) {
        this.addProductoDialog = true;
        this.addProducto.idgrupo = idgrupo;
      },
      addProductoMetodoConfirmar() {
        let fI = this.menu.grupos.findIndex(
          (g) => g.id == this.addProducto.idgrupo
        );
        if (fI > -1) {
          this.menu.grupos[fI].productosGrupo.push({ ...this.addProducto });
        }
        this.addProductoDialog = false;
      },
      goBack() {
        this.$router.go(-1);
      },

      save() {
        this.loadingGuardar = true;
        this.loading = true;
        /*this.grupoModificador.modificadores.forEach((m) => {
        m.opciones.forEach((op) => {
          delete op.tarifas, delete op.manejando;
        });
      });*/
        console.log(this.menu);
        if (!!this.imagenAux) {
          this.menu.imagenModel = this.imagenAux;
        }

        var nuevo = !this.menu.id;
        var id = this.menu.id;

        this.$store
          .dispatch('productos/addMenu', this.menu)
          .then((r) => {
            this.$store.commit('snackbar/setMensajeSuccess', {
              msj: 'Menú guardado',
            });
            if (nuevo) {
              id = r;
            }

            return this.$store.dispatch('productos/getMenu', id);
          })

          .then((r) => {
            console.log(r);
            this.menu = { ...r, id: id };
          })

          .catch((error) => {
            console.log(error);
            this.$store.commit('snackbar/setMensajeDanger', {
              msj: 'Error al actualizar el menú: ' + error,
            });
          })
          .finally(() => {
            this.loadingGuardar = false;
            this.loading = false;
          });
      },
      addGrupo() {
        let i_panel = this.menu.grupos.length;
        let agregar = {
          id: key(),
          nombre: [],
          descripcion: [],
          productosGrupo: [],
        };
        this.idiomas.forEach((lang) => {
          agregar.nombre.push({
            lang: lang.value,
            text: 'Grupo ' + lang.text,
          });
          agregar.descripcion.push({
            lang: lang.value,
            text: 'Descripción ' + lang.text,
          });
        });
        this.menu.grupos.push(agregar);
      },
      borrarGrupo(i) {
        this.menu.grupos.splice(i, 1);
      },
      borrarProductoGrupo(op) {
        console.log(op);
        let fIGrupo = this.menu.grupos.findIndex((g) => g.id == op.idgrupo);
        if (fIGrupo > -1) {
          let fIP = this.menu.grupos[fIGrupo].productosGrupo.findIndex(
            (p) => p.producto == op.producto
          );
          if (fIP > -1) this.menu.grupos[fIGrupo].productosGrupo.splice(fIP, 1);
        }
      },
    },
    mounted() {
      /*new Sortable(
      this.$refs.sortableTable.$el.getElementsByTagName("tbody")[0],
      {
        draggable: ".sortableRow",
        handle: ".sortHandle",
        onEnd: this.dragReorder,
      }
    );*/

      if (this.$route.params.id) {
        //obtenemos modificador
        this.$store
          .dispatch('productos/getMenu', this.$route.params.id)
          .then((r) => {
            this.menu = { ...r, id: this.$route.params.id, menu: true };
            if (
              !Array.isArray(this.menu.nombre) ||
              this.menu.nombre.length == 0
            ) {
              this.menu.nombre = [];
              this.menu.descripcion = [];
              this.idiomas.forEach((lang) => {
                this.menu.nombre.push({
                  lang: lang.value,
                  text: 'Menu ' + lang.text,
                });
                this.menu.descripcion.push({
                  lang: lang.value,
                  text: 'Descripción ' + lang.text,
                });
              });
            }
          });
      } else {
        this.idiomas.forEach((lang) => {
          this.menu.nombre.push({
            lang: lang.value,
            text: 'Menu ' + lang.text,
          });
          this.menu.descripcion.push({
            lang: lang.value,
            text: 'Descripción ' + lang.text,
          });
        });
      }
    },
  };
</script>

<style></style>
